import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';
import { useSignup } from '../../../contexts/SignupContext';

const DEMO_AADHAAR_REF_ID = 'WEBDEMOAAD123';
const DEMO_AADHAAR_OTP = '654321';

const SignupAadhaar = () => {
  const navigate = useNavigate();
  const { updateSignupState } = useSignup();
  const [aadhaar, setAadhaar] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (aadhaar.trim().length !== 12) {
      toast.error('Please enter a 12-digit Aadhaar number');
      return;
    }

    setLoading(true);

    updateSignupState({
      aadhaarRefId: DEMO_AADHAAR_REF_ID,
      aadhaarOtp: DEMO_AADHAAR_OTP,
    });

    toast.success('Aadhaar OTP sent');
    toast.info(`Demo Aadhaar OTP is ${DEMO_AADHAAR_OTP}.`);
    navigate('/signup/aadhaar-otp');
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Verify Aadhaar"
      subtitle="Enter your Aadhaar number to receive OTP"
      onBack={() => navigate(-1)}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Aadhaar Number</label>
          <input
            type="tel"
            className="form-input"
            value={aadhaar}
            maxLength={12}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');
              setAadhaar(value);
            }}
            placeholder="Enter Aadhaar number"
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Sending OTP...' : 'Send OTP'}
        </button>
      </form>
      <div className="signup-section" style={{ marginTop: '1.5rem' }}>
        <p className="signup-text">
          Don&apos;t have Aadhaar OTP?{' '}
          <button
            type="button"
            className="signup-link"
            onClick={() => navigate('/signup/aadhaar-upload')}
          >
            Skip and upload Aadhaar
          </button>
        </p>
      </div>
    </AuthLayout>
  );
};

export default SignupAadhaar;


